import { BrowserRouter, Routes, Route } from "react-router";
import OrcaLoginScreen from "./pages/login";
import Analysis from "./pages/analysis";
import Dashboard from "./pages/dashboard";
import ChatInterface from "./pages/chat";
import ImageInverter from "./pages/imageInverter";
import Lab from "./pages/lab";
import PromptManagement from "./pages/prompt-management";

const ApplicationRoutes = () => { 
    return(
    <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<OrcaLoginScreen />} /> */}
          <Route path="/" element={<Lab />} />
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/chat" element={<ChatInterface />} />
          <Route path="/imageinverter" element={<ImageInverter />} />
          <Route path="/prompt-management" element={<PromptManagement />} />
        </Routes>
    </BrowserRouter>
    )
}
export default ApplicationRoutes;